import React from 'react';
import { Typography } from 'antd';
import { getContentWrapperStyle } from '../templateStyles';

const { Title, Paragraph } = Typography;

export default function SectionCustomHTML({ section, siteInfo }) {
  const html = section.config?.html || '';
  if (!html) return null;

  const brandColor = siteInfo?.brand_color || '#1890ff';
  const template = siteInfo?.site_template || 'modern';
  const isMinimal = template === 'minimal';
  const contentFont = getContentWrapperStyle(template, brandColor);

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '48px 24px', ...contentFont }}>
      {section.title && (
        <Title level={2} style={{
          textAlign: isMinimal ? 'left' : 'center',
          marginBottom: 8,
          fontWeight: isMinimal ? 300 : 600,
          letterSpacing: isMinimal ? 1 : 0,
          borderBottom: isMinimal ? `2px solid ${brandColor}` : 'none',
          paddingBottom: isMinimal ? 8 : 0,
          display: isMinimal ? 'inline-block' : 'block',
        }}>
          {section.title}
        </Title>
      )}
      {section.subtitle && (
        <Paragraph style={{
          textAlign: isMinimal ? 'left' : 'center',
          color: '#666',
          marginBottom: 24,
        }}>
          {section.subtitle}
        </Paragraph>
      )}
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
